import React from 'react';
import { DialogManager } from '../fasades/dialogmanager';
import { IModel } from '../chatbot/api/llmapi';
import { LogSliderComp } from '../chatbot/components/logslidercomp';
import { SliderComp } from '../chatbot/components/slidercomp';

type NewModelProps = {
    input     : IModel;

    onCancel?  : () => void;
    onApply?    : (data: IModel) => void;
};

export class ModelParametersDialog extends React.Component<NewModelProps, IModel> {
    dialogRef    = React.createRef<HTMLDialogElement>();

    constructor(props: NewModelProps) {
        super(props);
        this.state = props.input;
    }

    componentDidMount() {
        // Show the dialog when the component mounts
        if (this.dialogRef.current) {
          this.dialogRef.current.showModal();
        }
    }

    handleCancel()
    {
        if (this.props.onCancel) {
            this.props.onCancel();
        }

        this.handleClose();
    }

    handleClose()
    {
        if (this.dialogRef.current) {
            this.dialogRef.current.close();
        }
        DialogManager.close();
    }

    handleChange(e : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)
    {
        if (e.target.name === "name") {
            this.setState({ name : e.target.value });
        }
        else if (e.target.name === "description") {
            this.setState({ description : e.target.value });
        }
    }

    handleChangeLearingRate(rate : number)
    {
        this.setState({ learning_rate : rate });
    }

    handleLearningSteps(e : React.ChangeEvent<HTMLInputElement>)
    {
        this.setState({ learning_steps : parseInt(e.target.value) });
    }

    handleNewModel()
    {
        if (this.props.onApply) {
            this.props.onApply(this.state);
        }

        this.handleClose();
    };

    render() {
        return (
          <dialog ref={this.dialogRef} className="dialogStyle">
            <h2 style={{marginTop: 0}}>Model Properties</h2>
            <form method="dialog" onSubmit={e => e.preventDefault()}>
              <label className="labelStyle" htmlFor="name">Name</label>
              <input
                className="inputStyle"
                id="name"
                name="name"
                type="text"
                value={this.state.name}
                required
                readOnly
              />

              <SliderComp
                name     = "Temperature"
                input    = {this.state.temperature}
                steps    = {100}
                minValue = {0}
                maxValue = {1}
                onChange = {(value : number) => { this.setState({ temperature : value }); } }
              />

              <SliderComp
                name     = "Top P"
                input    = {this.state.topP}
                steps    = {300}
                minValue = {0}
                maxValue = {1}
                onChange = {(value : number) => { this.setState({ topP : value }); } }
              />


              <label className="labelStyle" htmlFor="steps">Learning Steps</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <input
                  style={{ flex: 1 }}
                  id="steps"
                  name="steps"
                  type="range"
                  min={1}
                  max={100}
                  step={1}
                  value={this.state.learning_steps}
                  onChange={(e) => this.handleLearningSteps(e) }
                />
                <span style={{ minWidth: '2.5rem', textAlign: 'center', fontWeight: 'bold' }}>
                  { this.state.learning_steps }
                </span>
              </div>

              <LogSliderComp
                name     = "Learning Rate"
                input    = {this.state.learning_rate}
                steps    = {300}
                minValue = {1E-6}
                maxValue = {1E-3}
                onChange = {(value : number) => { this.handleChangeLearingRate(value); } }
              />

              <SliderComp
                name     = "Epsilon"
                input    = {this.state.epsilon}
                steps    = {300}
                minValue = {0}
                maxValue = {1}
                onChange = {(value : number) => { this.setState({ epsilon : value }); } }
              />

              <SliderComp
                name     = "Beta"
                input    = {this.state.beta}
                steps    = {300}
                minValue = {0}
                maxValue = {1}
                onChange = {(value : number) => { this.setState({ beta : value }); } }
              />

              <div className="buttonRowStyle">
                <button type="button" className="buttonStyle cancelStyle" onClick={() => this.handleCancel()}>
                  Cancel
                </button>
                <button type="button" className="buttonStyle saveStyle" onClick={() => this.handleNewModel()}>
                  Apply
                </button>
              </div>
            </form>
          </dialog>
        );
      }

    static showDialog(model : IModel) : Promise<void> 
    {
        return new Promise((resolve, reject) => {
            DialogManager.open(
                <ModelParametersDialog
                    input={ model }
                    onApply={(data: IModel) => { Object.assign(model, data); resolve() } }
                    onCancel={() => reject(new Error("Cancelled!"))}/>
            );
        });
    }
}

